// Ways a provider can get paid for a listing.
// The selected options are saved to listing's publicData.paymentOptions.

// Buyers pay online (Stripe). Provider needs payout details before the listing can be published.
export const PAYMENT_OPTION_SECURE = 'secure';
// Provider and buyer arrange the sale and payment between themselves. No payout details needed.
export const PAYMENT_OPTION_DIRECT = 'direct';

/**
 * Get the payment options of a listing.
 *
 * Listings created before payment options were introduced don't have the value saved.
 * Those were all sold through Stripe, so they are treated as secure payment listings.
 *
 * @param {Object} publicData listing's publicData
 * @returns {Array<string>} selected payment options
 */
export const getPaymentOptions = publicData => {
  const paymentOptions = publicData?.paymentOptions;
  return Array.isArray(paymentOptions) && paymentOptions.length > 0
    ? paymentOptions
    : [PAYMENT_OPTION_SECURE];
};

/**
 * Payout details are needed only if the provider wants to be paid through secure online payment.
 * If only "sell direct" is selected, payout details are not required.
 *
 * @param {Object} publicData listing's publicData
 * @returns {boolean}
 */
export const isSecurePaymentSelected = publicData =>
  getPaymentOptions(publicData).includes(PAYMENT_OPTION_SECURE);
